export const SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE = 'SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE'

export const saveHealthPlanSelectionFromTriage = (selectedHealthPlan: $TSFixMe) => {
  return {
    type: SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE,
    selectedHealthPlan,
  }
}
